import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth.module';
import user from './user.module';
import data from './data.module';
import logs from './logs.module';
import users from './users.module';
import dashboard from './dashboard.module';
import projects from './projects.module';
import languages from './languages.module';
import translators from './translators.module';
import projectKeys from './projectKeys.module';
import projectTranslations from './projectTranslations.module';
import projectPages from './projectPages.module';
import deeplTranslations from './deeplTranslations.module';
import automateddeeplTranslations from './automateddeeplTranslations.module';
import search from './search.module';
import typesense from './typesense.module';

Vue.use(Vuex);

const modules = {
  auth,
  user,
  data,
  logs,
  users,
  dashboard,
  projects,
  languages,
  translators,
  projectKeys,
  projectTranslations,
  projectPages,
  deeplTranslations,
  automateddeeplTranslations,
  search,
  typesense,
};

export default new Vuex.Store({
  strict: false,
  state: {
    pageTitle: null,
    sidebar: false,
    centered: false,
    stretch: false,
  },
  getters: {
    pageTitle: (state) => state.pageTitle || 'Home',
    sidebar: (state) => (state.sidebar != null ? state.sidebar : true),
    centered: (state) => (state.centered != null ? state.centered : false),
    stretch: (state) => (state.stretch != null ? state.stretch : false),
  },
  mutations: {
    pageTitle(state, title) {
      state.pageTitle = title;
    },
    sidebar(state, enabled) {
      state.sidebar = enabled;
    },
    centered(state, enabled) {
      state.centered = enabled;
    },
    stretch(state, enabled) {
      state.stretch = enabled;
    },
  },
  actions: {
    clearErrors({ commit }) {
      Object.keys(modules)
        .forEach((module) => commit(`${module}/clearErrors`));
    },
  },
  modules,
});
